import {
  CustomCollapseCard,
  CustomCollapse,
  CustomForm,
  CustomCheckbox,
  CustomPageHeader,
  CustomFormItem,
  CustomSelect,
  Option,
  Text,
  useText,
  CustomButton,
  CustomTabs,
  CustomInput,
  CustomMaskInput,
} from '@src/components';
import React from 'react';
import '@src/styles/managementUser/addUser.scss';
import { Radio } from 'antd';
import { useSelector } from 'react-redux';
import {
  SearchInput,
  VouPagination,
  CheckboxFormItem,
  CheckboxItem,
} from '@src/components/managementUser/EditUserFormParts';
import useEditUserLogic from '@src/components/managementUser/useEditUserLogic';
import { formPhoneRegex } from '@src/utils/formRule';

const MGMT_USER_ROUTE = '/company-information/management-user';

const EditUser = () => {
  const { selectedCustomer } = useSelector((state) => state?.customer);

  const {
    form,
    activeProductList,
    userTypeList,
    selectedRole,
    handleRoleSelect,
    currentFormValues,
    addressText,
    setAddressText,
    addressSearchText,
    claimsSearchText,
    setClaimsSearchText,
    searchText,
    addressList,
    claims,
    isProductChecked,
    clickActiveProduct,
    getAddressList,
    getClaimList,
    handleAddressChange,
    handleClaimsChange,
    changeAddressPagination,
    changeClaimsPagination,
    handleAddressSelectionTypeChange,
    tabChange,
    cancel,
    onFinish,
  } = useEditUserLogic({
    mgmtUserRoute: MGMT_USER_ROUTE,
    customerId: selectedCustomer?.customerId,
    includeContactFieldsInNonRole3Payload: true,
    navigateOnNonRole3Success: true,
  });

  const renderClaimCheckbox = (vou) => (claim) =>
    (
      <CheckboxItem
        key={claim.id}
        id={`companyInformation-managementUser-editUser-claims-${claim?.groupName}-checkbox`}
        value={claim?.id}
        disabled={claim?.isDisabled || selectedRole === 4}
        label={<Text t={claim.groupName} />}
        onChange={(e) => handleClaimsChange(e.target.checked, vou?.vouId, claim)}
      />
    );

  return (
    <CustomPageHeader title={<Text t="userManagement" />} showBreadCrumb showHelpButton>
      <CustomCollapseCard className="add-user-card" cardTitle={<Text t="userEdit" />}>
        <CustomForm
          name="userSelectForm"
          className="user-select-form add-user-form"
          autoComplete="off"
          layout={'horizontal'}
          form={form}
        >
          <div className="section-wrapper">
            <div className="section-list">
              <div className="user-select-content">
                <div className="form-item-main">
                  <CustomFormItem
                    label={
                      <div>
                        <Text t="userRole" />
                      </div>
                    }
                    name="groupId"
                  >
                    <CustomSelect
                      id="companyInformation-managementUser-editUser-groupId-select"
                      onChange={handleRoleSelect}
                      placeholder={useText('choose')}
                      height={36}
                    >
                      {userTypeList?.map((item) => (
                        <Option
                          id={`companyInformation-managementUser-editUser-groupId-${item.name}-option`}
                          key={item.id}
                          value={item.id}
                        >
                          {item.name}
                        </Option>
                      ))}
                    </CustomSelect>
                  </CustomFormItem>
                  <CustomFormItem
                    label={
                      <div>
                        <Text t="name3" />
                        <span>:</span>
                      </div>
                    }
                    name="name"
                    className="custom-form-item"
                    rules={[{ required: true, message: <Text t="requiredField2" /> }]}
                  >
                    <CustomInput
                      id="companyInformation-managementUser-editUser-name-input"
                      autoComplete="off"
                      height={36}
                      maxLength={100}
                    />
                  </CustomFormItem>
                  <CustomFormItem
                    label={
                      <div>
                        <Text t="surname2" />
                        <span>:</span>
                      </div>
                    }
                    name="surName"
                    className="custom-form-item"
                    rules={[{ required: true, message: <Text t="requiredField2" /> }]}
                  >
                    <CustomInput
                      id="companyInformation-managementUser-editUser-surName-input"
                      autoComplete="off"
                      height={36}
                      maxLength={100}
                    />
                  </CustomFormItem>
                  <CustomFormItem
                    label={
                      <div>
                        <Text t="eMailAddress" />
                      </div>
                    }
                    name="email"
                    className="custom-form-item"
                  >
                    <CustomInput
                      id="companyInformation-managementUser-editUser-email-input"
                      autoComplete="off"
                      height={36}
                      disabled={true}
                      style={{ width: 257 }}
                      maxLength={100}
                    />
                  </CustomFormItem>
                  <CustomFormItem
                    label={
                      <div>
                        <Text t="phoneNumber2" />
                        <span>:</span>
                      </div>
                    }
                    name="mobilePhones"
                    rules={[
                      { required: true, message: <Text t="pleaseEnterPhone" /> },
                      { validator: formPhoneRegex, message: <Text t="enterValidPhoneNumber" /> },
                    ]}
                  >
                    <CustomMaskInput
                      id="companyInformation-managementUser-editUser-mobilePhones-maskInput"
                      mask={'+\\90 (999) 999 99 99'}
                    >
                      <CustomInput
                        id="companyInformation-managementUser-editUser-mobilePhones-input"
                        data-testid="mobilePhones"
                        placeholder="+90( _ _ _ ) _ _ _  _ _  _ _"
                        height={36}
                      />
                    </CustomMaskInput>
                  </CustomFormItem>
                </div>
              </div>
            </div>
          </div>

          <h5>
            <Text t="activeProducts" />
          </h5>

          {activeProductList?.map((product) => {
            return (
              <CustomCollapse
                key={product.groupId}
                cardTitle={
                  <div className="d-flex align-items-center">
                    <CustomCheckbox
                      id={`companyInformation-managementUser-editUser-activeProductList-${product?.groupName}-checkbox`}
                      className="collapse-header-checkbox"
                      value={product.groupId}
                      checked={isProductChecked(product)}
                      onClick={(e) => {
                        e.stopPropagation();
                        clickActiveProduct(product);
                      }}
                      disabled={selectedRole === 4 && product.groupId === 5000001}
                    />
                    {product.groupName}
                  </div>
                }
              >
                <CustomTabs
                  tabs={product?.vous?.map((vou) => {
                    return {
                      key: vou?.vouId,
                      name: vou?.vouName,
                      content: (
                        <div className="form-content">
                          {vou?.vouId !== 5000002 && (
                            <>
                              <div className="form-item ">
                                <p className="form-title">
                                  <Text t="deliveryAddresses2" />
                                </p>
                                <CustomFormItem
                                  label={false}
                                  name={['products', vou.vouId, 'vouId']}
                                  className="u-p-l-3"
                                  hidden
                                />
                                <CustomFormItem
                                  label={false}
                                  name={['products', vou.vouId, 'groupId']}
                                  className="u-p-l-3"
                                  hidden
                                />
                                <CustomFormItem
                                  label={false}
                                  name={['products', vou.vouId, 'addressSelectionType']}
                                  className="u-p-l-3"
                                >
                                  <Radio.Group
                                    id="companyInformation-managementUser-editUser-custom-radio-input-content"
                                    onChange={(e) =>
                                      handleAddressSelectionTypeChange(vou.vouId, e?.target?.value)
                                    }
                                    className="custom-radio-input-content"
                                  >
                                    <Radio
                                      value={false}
                                      id="companyInformation-managementUser-editUser-all-delivery-address-radio"
                                    >
                                      <div className="custom-label">
                                        <Text t="forAllDeliveryAddresses" />
                                      </div>
                                    </Radio>
                                    <Radio
                                      value={true}
                                      id="companyInformation-managementUser-editUser-choose-delivery-address-radio"
                                    >
                                      <div className="custom-label">
                                        <Text t="onlyAtSelectedDeliveryAddresses" />
                                      </div>
                                    </Radio>
                                  </Radio.Group>
                                </CustomFormItem>
                              </div>
                              {currentFormValues?.products[vou?.vouId]?.addressSelectionType ===
                                true && (
                                <div>
                                  <div className="u-m-t-5">
                                    <SearchInput
                                      id="customer-managementUser-editUser-custom-search-input"
                                      value={addressText[vou?.vouId]}
                                      placeholder={addressSearchText}
                                      onChange={(e) =>
                                        setAddressText({
                                          ...addressText,
                                          [vou?.vouId]: e.target.value,
                                        })
                                      }
                                      onSearch={() =>
                                        getAddressList(1, 10, vou?.vouId, addressText[vou?.vouId])
                                      }
                                    />
                                  </div>
                                  <CheckboxFormItem
                                    formItemName={['products', vou.vouId, 'addressList']}
                                    items={addressList[vou?.vouId]?.data}
                                    renderItem={(address) => (
                                      <CheckboxItem
                                        key={address?.addressId}
                                        id={`companyInformation-managementUser-editUser-addressList-${address?.addressName}-checkbox`}
                                        value={address?.addressId}
                                        label={<Text t={address?.addressName} />}
                                        onChange={(e) =>
                                          handleAddressChange(
                                            e.target.checked,
                                            vou?.vouId,
                                            address?.addressId,
                                          )
                                        }
                                      />
                                    )}
                                  />
                                  <hr />
                                  <VouPagination
                                    pagedProperty={addressList[vou?.vouId]?.pagedProperty}
                                    onChange={(pageNumber, pageSize) =>
                                      changeAddressPagination(pageNumber, pageSize, vou?.vouId)
                                    }
                                  />
                                </div>
                              )}
                            </>
                          )}
                          <>
                            <p className="form-title u-m-t-5">
                              <Text t="functions" />
                            </p>
                            <SearchInput
                              id="customer-managementUser-editUser-second-custom-search-input"
                              value={claimsSearchText[vou?.vouId]}
                              placeholder={searchText}
                              onChange={(e) =>
                                setClaimsSearchText({
                                  ...claimsSearchText,
                                  [vou?.vouId]: e.target.value,
                                })
                              }
                              onSearch={() =>
                                getClaimList(1, 10, vou?.vouId, claimsSearchText[vou?.vouId])
                              }
                            />
                          </>
                          <CheckboxFormItem
                            formItemName={['products', vou.vouId, 'groupIds']}
                            items={claims[vou.vouId]?.data}
                            renderItem={renderClaimCheckbox(vou)}
                          />
                          <hr />
                          {claims[vou?.vouId]?.data?.length > 0 && (
                            <VouPagination
                              pagedProperty={claims[vou.vouId]?.pagedProperty}
                              onChange={(pageNumber, pageSize) =>
                                changeClaimsPagination(pageNumber, pageSize, vou?.vouId)
                              }
                            />
                          )}
                        </div>
                      ),
                    };
                  })}
                  onChange={tabChange}
                />
              </CustomCollapse>
            );
          })}

          <div className="footer-form-buttons">
            <CustomButton
              id="companyInformation-managementUser-editUser-custom-btn-cancel"
              className="custom-btn-cancel"
              onClick={() => cancel()}
            >
              <Text t="giveUp" />
            </CustomButton>
            <CustomButton
              id="companyInformation-managementUser-editUser-custom-btn-save"
              onClick={() => onFinish()}
              className="custom-btn-save"
            >
              <Text t="saveChanges" />
            </CustomButton>
          </div>
        </CustomForm>
      </CustomCollapseCard>
    </CustomPageHeader>
  );
};

export default EditUser;
